export interface MaintenanceConfig {
  active: boolean;
  message: string;
  startTime: string;
  endTime: string;
  updatedBy?: string;
  updatedAt?: string;
}
